import * as React from 'react';
import { UIEThemeContext } from './UIEThemeContext';
export function withUIETheme(Component) {
    return function BoundComponent(props) {
        return (React.createElement(UIEThemeContext.Consumer, null, (value) => React.createElement(Component, { uieTheme: value, ...props })));
    };
}
//# sourceMappingURL=withUIETheme.js.map